<template>
  <div>
    <!-- Product feature list start -->
    <section class="hot-features-area" id="productsDetail">
      <div class="container animated bounceInUp">
        <div class="section-header-2 wow fadeIn" data-wow-offset="10" data-wow-duration="1.5s">
          <div class="section-description" style="z-index: 999;">
            <p class="features-title">
              <span>Products Of <span style="font-weight: 600;">ANOVATOR</span></span>
            </p>
          </div>
        </div>
        <div class="row hot-features" style="margin-top: 40px;">
          <!-- A5 Product -->
          <div class="col-lg-3">
            <div class="product-features a5-item">
              <div class="model-name">ANOVATOR A5</div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Body composition analysis</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Athletic capacity Analysis</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Sp02</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Sports safety Analysis</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Balance Assessment</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Heart Rate Test</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Response Assessment</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Body posture Analysis</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Detection Data Analysis</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Visual acuity Assessment</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Shoulder Joint Range of motionEvaluation Function</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Test Report</div>
              </div>
              <button class="btn-more" @click="goToProduct('a5')">MORE</button>
            </div>
          </div>
          
          <!-- M3 Product -->
          <div class="col-lg-3">
            <div class="product-features m3-item">
              <div class="model-name">ANOVATOR M3</div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Body composition analysis</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Athletic capacity Analysis</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Sp02</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Sports safety Analysis</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Balance Assessment</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Heart Rate Test</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Response Assessment</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Body posture Analysis</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Detection Data Analysis</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Visual acuity Assessment</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Shoulder Joint Range of motionEvaluation Function</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Test Report</div>
              </div>
              <button class="btn-more" @click="goToProduct('m3')">MORE</button>
            </div>
          </div>
          
          <!-- M1 Product -->
          <div class="col-lg-3">
            <div class="product-features m1-item">
              <div class="model-name">ANOVATOR M1</div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Body composition analysis</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Athletic capacity Analysis</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Sp02</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Sports safety Analysis</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Balance Assessment</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Heart Rate Test</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Response Assessment</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Body posture Analysis</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Detection Data Analysis</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Visual acuity Assessment</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Shoulder Joint Range of motionEvaluation Function</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Test Report</div>
              </div>
              <button class="btn-more" @click="goToProduct('m1')">MORE</button>
            </div>
          </div>
          
          <!-- M0 Product -->
          <div class="col-lg-3">
            <div class="product-features m0-item">
              <div class="model-name">ANOVATOR M0</div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Body composition analysis</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Athletic capacity Analysis</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Sp02</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Sports safety Analysis</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Balance Assessment</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Heart Rate Test</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Response Assessment</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Body posture Analysis</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Detection Data Analysis</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Visual acuity Assessment</div>
              </div>
              <div class="function-item">
                <div class="untick-ico">×</div>
                <div class="function-name">Shoulder Joint Range of motionEvaluation Function</div>
              </div>
              <div class="function-item">
                <div class="tick-ico">✔</div>
                <div class="function-name">Test Report</div>
              </div>
              <button class="btn-more" @click="goToProduct('m0')">MORE</button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Product feature list end -->
    
    <!-- Global presence section start -->
    <section class="hot-features-area">
      <div class="container animated bounceInUp">
        <div class="section-header-2 wow fadeIn" data-wow-offset="10" data-wow-duration="1.5s">
          <div class="section-description" style="z-index: 999;">
            <p class="features-title">
              <span><span style="font-weight: 600;">ANOVATOR</span> On the way</span>
            </p>
          </div>
        </div>
        <div class="row hot-features" style="padding: 0;position: relative;">
          <div class="dealer-box">
            <div class="indicator">
              11.84M+
              <div>Tests</div>
            </div>
            <div class="indicator">
              8.42M+
              <div>User</div>
            </div>
            <div class="indicator">
              200M+
              <div>Records</div>
            </div>
            <div class="indicator">
              20,598+
              <div>Supporting stores</div>
            </div>
            <div class="indicator">
              50+
              <div>Countries</div>
            </div>
          </div>
          <img 
            class="img-responsive map-img" 
            src="/static/images/map.png" 
            data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/map%402x.png" 
            alt="Global presence map"
          >
        </div>
      </div>
    </section>
    <!-- Global presence section end -->
  </div>
</template>

<script>
export default {
  name: 'ProductShowcase',
  methods: {
    goToProduct(productName) {
      this.$router.push(`/${productName}`)
    }
  }
}
</script>

<style scoped>
/* 组件特定样式 */
</style>